import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { Select } from '@ngxs/store';
import { BrandingData } from '@shared/models/account.model';
import { AccountState } from '@shared/states/account.state';
import { isEskoHostname } from '@shared/utilities/branding.utilities';
import { Observable } from 'rxjs';

@Component({
  selector: 'brand-icon',
  templateUrl: './brand-icon.component.html',
  styleUrls: ['./brand-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandIcon {
  @Input()
  @HostBinding('class')
  class: string;

  @Input()
  invert: boolean = false;

  isEsko = isEskoHostname();

  @Select(AccountState.parentBranding)
  readonly parentBranding$: Observable<BrandingData>;
}
